export const ADMIN_USER_ROW_SM = 88;

export const ADMIN_USER_ROW_LG = 108;
